import Categories from 'ContentUtils/constants/Categories';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISideNav from 'UIComponents/nav/UISideNav';
import EPPatagoniaCategoryNavItem from 'editor-components/sidebar/EPPatagoniaCategoryNavItem';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SideNavItem = ({
  langKey,
  isCurrentlySelectedContentType,
  updateCurrentContentTypeFilter
}) => {
  return /*#__PURE__*/_jsx(EPPatagoniaCategoryNavItem, {
    title: /*#__PURE__*/_jsx(View, {
      as: "span",
      paddingInlineStart: "250",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `contentManagementPanel.sideNav.${langKey}`
      })
    }),
    onClick: updateCurrentContentTypeFilter,
    "data-test-id": `${langKey}-sidenav`,
    isActive: isCurrentlySelectedContentType,
    level: 1
  });
};
const ContentManagementSideNav = ({
  currentlySelectedContentTypeId,
  updateCurrentContentTypeId
}) => {
  const handleUpdateCurrentContentTypeFilter = contentTypeId => {
    if (contentTypeId !== currentlySelectedContentTypeId) {
      updateCurrentContentTypeId(contentTypeId);
    }
  };
  return /*#__PURE__*/_jsxs(UISideNav, {
    children: [/*#__PURE__*/_jsx(SideNavItem, {
      langKey: "sitePages",
      updateCurrentContentTypeFilter: () => handleUpdateCurrentContentTypeFilter(Categories.site_page.id),
      isCurrentlySelectedContentType: currentlySelectedContentTypeId === Categories.site_page.id
    }), /*#__PURE__*/_jsx(SideNavItem, {
      langKey: "landingPages",
      isCurrentlySelectedContentType: currentlySelectedContentTypeId === Categories.landing_page.id,
      updateCurrentContentTypeFilter: () => handleUpdateCurrentContentTypeFilter(Categories.landing_page.id)
    }), /*#__PURE__*/_jsx(SideNavItem, {
      langKey: "blog",
      isCurrentlySelectedContentType: currentlySelectedContentTypeId === Categories.blog_post.id,
      updateCurrentContentTypeFilter: () => handleUpdateCurrentContentTypeFilter(Categories.blog_post.id)
    }), /*#__PURE__*/_jsx(SideNavItem, {
      langKey: "blogListingPage",
      isCurrentlySelectedContentType: currentlySelectedContentTypeId === Categories.blog_listing_page.id,
      updateCurrentContentTypeFilter: () => handleUpdateCurrentContentTypeFilter(Categories.blog_listing_page.id)
    })]
  });
};
export default ContentManagementSideNav;